import { render, staticRenderFns } from "./serverAdminDetail.vue?vue&type=template&id=68969b73&scoped=true"
import script from "./serverAdminDetail.vue?vue&type=script&lang=js"
export * from "./serverAdminDetail.vue?vue&type=script&lang=js"
import style0 from "./serverAdminDetail.vue?vue&type=style&index=0&id=68969b73&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68969b73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68969b73')) {
      api.createRecord('68969b73', component.options)
    } else {
      api.reload('68969b73', component.options)
    }
    module.hot.accept("./serverAdminDetail.vue?vue&type=template&id=68969b73&scoped=true", function () {
      api.rerender('68969b73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/serverAdminDetail.vue"
export default component.exports